import React, { useEffect, useState } from 'react';
import SectionLayout from '../layouts/SectionLayout/index';
import Skeleton from '@mui/material/Skeleton';
import loadable from '@loadable/component';
import { motion, useAnimation } from 'framer-motion';
import { makeStyles } from '@mui/styles';
import { useInView } from 'react-intersection-observer';
import pMinDelay from 'p-min-delay';

const ProjectsCarouselV2 = loadable(
  () => pMinDelay(import('../ProjectsCarouselV2/index'), 300),
  {
    fallback: (
      <div className="flex min-h-[500px] w-full justify-center">
        <LoadingSkeleton></LoadingSkeleton>
      </div>
    ),
  },
);

const ProjectsV2 = ({ projects, type, ...props }) => {
  return (
    <SectionLayout
      heading={<>Projects You'll Build</>}
      description={
        <>
          Ship ${type === 'FSP' ? '6' : '8+'} Industry Projects that demonstrate
          full-stack mastery and AI engineering capabilities
        </>
      }
      {...props}
    >
      <div className="container">
        <div className="flex w-full flex-col items-center gap-4 ">
          <FadeInWhenVisible
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 },
            }}
          >
            <ProjectsCarouselV2 projects={projects} {...props} type={type} />
          </FadeInWhenVisible>
        </div>
      </div>
    </SectionLayout>
  );
};

function LoadingSkeleton() {
  const classes = useStyles();

  return (
    <div className="grid h-full w-full grid-cols-2 gap-6 overflow-hidden">
      {Array(4)
        .fill()
        .map((ele, idx) => (
          <div key={idx} className={`${classes.avatarSkeletonContainer}`}>
            <Skeleton className={classes.avatarLoader} animation="wave" />
          </div>
        ))}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  avatarSkeletonContainer: {
    height: 0,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    borderRadius: '20px',
    height: '400px',
  },
  avatarLoader: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transform: 'scale(1)',
  },
}));

function FadeInWhenVisible(props) {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  const [hasComeInViewOnce, setHasComeInViewOnce] = useState(false);

  useEffect(() => {
    if (inView) {
      controls.start('visible');
      setHasComeInViewOnce(true);
    }
  }, [controls, inView]);

  return (
    <motion.div
      className="w-full"
      ref={ref}
      animate={controls}
      initial="hidden"
      transition={{ duration: props.duration ? props.duration : 0.8 }}
      {...props}
    >
      {hasComeInViewOnce ? props.children : ''}
    </motion.div>
  );
}

export default ProjectsV2;
